import {InlineDatumReactComponentProps} from '@stripe-internal/inline-data';
import {view} from '@sail/ui';
import {LightCard} from '@stripe-internal/conversations-ui';
import {CurrentMerchantSection} from '../helpers/CurrentMerchantSection';
import {ContactInfoSection} from './ContactInfoSection';

export type ValueProps = {
  platform_name?: string;
  platform_link?: string;
  platform_email?: string;
  platform_phone?: string;
  platform_avatar?: string;
  has_contact_info?: boolean;
};

export const ExpressDeleteAccount = (props: InlineDatumReactComponentProps) => {
  const {datum} = props;
  const value = datum.value as ValueProps;

  const {
    platform_name: platformName,
    platform_link: platformLink,
    platform_email: platformEmail,
    platform_phone: platformPhone,
    platform_avatar: platformAvatar,
  } = value;

  return (
    <LightCard isOuter>
      <view.div
        css={{stack: 'y', gap: 'medium'}}
        data-testid="express-delete-account-card-1"
      >
        {platformName ? (
          <CurrentMerchantSection
            merchantName={platformName}
            merchantAvatar={platformAvatar}
          />
        ) : null}
        <ContactInfoSection
          platformLink={platformLink}
          platformEmail={platformEmail}
          platformPhone={platformPhone}
        />
      </view.div>
    </LightCard>
  );
};
